import React from "react";
//import { Link } from 'react-router-dom';

//import PropTypes from 'prop-types';
import ScrollableAnchor from "react-scrollable-anchor";
import TabLinks from "./tabLink";

const GAToZLoader = ({ item, type }) => {
  if (item.length > 0) {
    const headerletter = item[0].currentLetter.substring(0, 1);
    return (
      <div
        className="degreeBlock card"
        style={{
          backgroundColor: "#fff",
          display: "inline-block",
          borderRadius: "2px",
          padding: "25px",
          boxShadow:
            "0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23)",
          margin: "3px auto 24px",
          width: "344px",
          WebkitBoxSizing: "border-box",
          boxSizing: "border-box",
          flexDirection: "row",
          position: "relative",
          textAlign: "left"
        }}
      >
        <ScrollableAnchor id={item[0].currentLetter}>
          <div
            className="degrees"
            style={{
              position: "absolute",
              top: "0px",
              left: "25px"
            }}
          >
            <h3
              className={"headerLetter " + headerletter.toLowerCase()}
              style={{
                fontFamily: "'alphabeta'",
                fontSize: "2em",
                marginBottom: "-1.5em",
                height: "2.0625em",
                display: "block",
                marginTop: "28px"
              }}
            >
              {headerletter}
            </h3>
          </div>
        </ScrollableAnchor>
        <div
          className="degreeInnerBlock"
          style={{
            display: "block",
            float: "left",
            marginLeft: "1em",
            maxWidth: "26.875em"
          }}
        >
          {item.map((course, i) => (
            <ul key={i} className="degree">
              {type === "G" ? (
                course.graduate.url ? (
                  <TabLinks
                    url={course.graduate.url}
                    label={course.label}
                    title={course.graduate.title}
                    id={"g" + i}
                  />
                ) : (
                  <span>
                    {course.graduate.label} {course.graduate.title}
                  </span>
                )
              ) : course.accelerated.url ? (
                <TabLinks
                  url={course.accelerated.url}
                  label={course.title}
                  title={course.accelerated.title}
                  id={"a" + i}
                />
              ) : (
                <span>{course.accelerated.title}</span>
              )}
            </ul>
          ))}
        </div>
      </div>
    );
  } else {
    return null;
  }
};

export default GAToZLoader;
